import computeClassName from '../../../../../utils/computeClassName';
import CCIconClose8x8 from '../../Icon/Close/8x8';
import CCIconClose12x12 from '../../Icon/Close/12x12';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCBadgeLightRemoveControl',
  CLASSNAME_BASE: 'appearance-none inline-flex flex-row items-center justify-center',
  CLASSNAME_DISABLED: {
    false: 'cursor-pointer text-cc-gray-dark',
    true: 'cursor-auto text-cc-gray'
  } ,
  CLASSNAME_SIZE: {
    badgeSize_small: '',
    badgeSize_medium: '',
    badgeSize_large: ''
  },
  CLOSE_ICON_COMPONENT: {
    badgeSize_small: CCIconClose8x8,
    badgeSize_large: CCIconClose12x12,
    badgeSize_medium: CCIconClose12x12
  },
});

export const propsDefaults = Object.freeze({
  title: 'Remove',
  isDisabled: false,
  fn: null,
  fnArgs: undefined,
  className: ''
});

function getComputedClassName(propsClassName, badgeSize, badgeColor, isDisabled) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_SIZE[`badgeSize_${badgeSize}`]} ${constants.CLASSNAME_DISABLED[isDisabled]}`);
}

function getCloseIconComponent(badgeSize) {
  return constants.CLOSE_ICON_COMPONENT[`badgeSize_${badgeSize}`];
}

function remove(fn, args) {
  if (!!fn && ('function' === typeof fn)) {
    if (undefined === args) {
      return () => fn();
    }
    else {
      return () => fn(args);
    }
  }
}

export default function CCBadgeLightRemoveControl(
  {
    badgeSize,
    badgeColor,
    title = propsDefaults.title,
    isDisabled = propsDefaults.isDisabled,
    fn = propsDefaults.fn,
    fnArgs = propsDefaults.fnArgs,
    className = propsDefaults.className
  }
) {
  const computedClassName = getComputedClassName(className, badgeSize, badgeColor, isDisabled);
  const CloseIconComponent = getCloseIconComponent(badgeSize);
  if (isDisabled) {
    return (
      <button className={computedClassName}
              aria-label={title}
              aria-disabled="true"
              disabled={true}>
        <span className="sr-only">{title}</span>
        <span aria-hidden="true"><CloseIconComponent/></span>
      </button>
    )
  }
  else {
    return (
      <button className={computedClassName}
              aria-label={title}
              title={title}
              onClick={remove(fn, fnArgs)}>
        <span className="sr-only">{title}</span>
        <span aria-hidden="true"><CloseIconComponent/></span>
      </button>
    );
  }
}
